import { useState } from 'react'
import { AxiosError } from 'axios'
import FirmViewContactInformation from 'src/components/portal/default/FirmViewComponents/FirmViewContactInformation'
import FirmViewAddresses from 'src/components/portal/default/FirmViewComponents/FirmViewAddresses'
import { FlexDiv, OrangeButton, OrangeButtonSimpleText } from 'src/components/portal/default'
import { useAuth } from 'src/context/auth'
import { useCustomer } from 'src/context/customer'
import { FirmDetailsUpdateAddressInputs, FirmDetailsUpdateContactsInputs } from 'src/dtos/portal'
import { api } from 'src/services/apiClient'
import Modal from 'react-modal'

const FirmInformation = () => {
  const { user } = useAuth()
  const { addressesData, getFirmDetails } = useCustomer()
  const [removeAddressModalOpen, setRemoveAddressModalOpen] = useState(false)
  const [addressModalBtnsDisabled, setAddressModalBtnsDisabled] = useState(false)

  const handleSaveAddressChange = async (addressInputs: FirmDetailsUpdateAddressInputs) => {
    try {
      await api.put('/Firm/address', { ...addressInputs })
      await getFirmDetails(user.firmId)
    } catch (error) {
      if (error instanceof AxiosError) {
        // Log actual error details to browser console
        if(error.response?.data?.errorDetails) {
          console.error(error.response.data.errorDetails)
        }
        throw new Error(error.response?.data?.errorMessage || 'An error occurred while saving address.')
      }
      throw error
    }
  }

  const handleRemoveBillingAddress = async () => {
    setAddressModalBtnsDisabled(true)
    try {
      await api.post('/Firm/RemoveFirmAddress', {}, {
        params: {
          firmId: user.firmId,
          type: 1
        }
      })
      await getFirmDetails(user.firmId)
      setRemoveAddressModalOpen(false)
    } catch (e) { } finally {
      setAddressModalBtnsDisabled(false)
    }
  }

  const handleSaveFirmContact = async (contactInputs: FirmDetailsUpdateContactsInputs) => {
    try {
      await api.put(`/Firm/contactinfo/${user.firmId}`, { ...contactInputs })
      await getFirmDetails(user.firmId)
    } catch (e) {}
  }
  
  return (
    <div>
      {user?.firmId ? (
        <FlexDiv dir="column" gap="48px">
          <FirmViewContactInformation 
            firmId={user.firmId.toString()}  
            isAdmin = {false}
          />
          <FirmViewAddresses
            addresses={addressesData}
            firmId={user.firmId}
            saveAddress={handleSaveAddressChange}
            removeBillingAddress={() => setRemoveAddressModalOpen(true)}
            saveContact={handleSaveFirmContact}
          />
        </FlexDiv>
      ) : null}
      <Modal
        isOpen={removeAddressModalOpen}
        onRequestClose={() => setRemoveAddressModalOpen(false)}
        overlayClassName="react-modal-overlay"
        className="react-modal-content"
      >
        <FlexDiv dir='column' gap="16px">
          <strong>Are you sure you want to remove this billing address?</strong>
          <span>This information will not be saved once it has been removed.</span>
          <FlexDiv dir="column" gap="24px" margin="48px 0 0 0" align='flex-end'>
            <OrangeButton
              onClick={handleRemoveBillingAddress}
              disabled={addressModalBtnsDisabled}
            >
              Remove Billing Address
            </OrangeButton>
            <OrangeButtonSimpleText
              onClick={() => setRemoveAddressModalOpen(false)}
              disabled={addressModalBtnsDisabled}
            >
              Cancel
            </OrangeButtonSimpleText>
          </FlexDiv>
        </FlexDiv>
      </Modal>
    </div>
  )
}

export default FirmInformation